import { render } from "./AuthorInfo.vue?vue&type=template&id=6e057d2d&scoped=true&ts=true"
import script from "./AuthorInfo.vue?vue&type=script&lang=ts"
export * from "./AuthorInfo.vue?vue&type=script&lang=ts"

import "./AuthorInfo.vue?vue&type=style&index=0&id=6e057d2d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e057d2d"]])

export default __exports__